module.exports = __webpack_public_path__ + "img/x1-three.03c443d7.png";